import { FactoryProvider } from '@angular/core';
import { Configuration as BBookLpApiConfiguration } from '@api/b-book-lp';
import { Configuration as CoreApiConfiguration } from '@api/core';
import { Configuration as FineryApiConfiguration } from '@api/finery';
import { Configuration as FireblocksApiConfiguration } from '@api/fireblocks';
import { Configuration as HiddenRoadApiConfiguration } from '@api/hidden-road';
import { Configuration as HouseLpApiConfiguration } from '@api/house-lp';
import { Configuration as MainBookLpApiConfiguration } from '@api/main-book-lp';
import { Configuration as PrincipalRiskLpApiConfiguration } from '@api/principal-risk-lp';
import { Configuration as SyntheticLpApiConfiguration } from '@api/synthetic-lp';
import { Configuration as ZerohashApiConfiguration } from '@api/zerohash';

import { environment } from 'environments/environment';
import { AuthService } from './auth.service';

interface ApiConfigurationCtor<TConfig> {
  new (params: { basePath: string; accessToken: () => string }): TConfig;
}

function makeApiConfigurationProvider<TConfig>(
  ConfigurationCtor: ApiConfigurationCtor<TConfig>,
  getBasePath: () => string,
): FactoryProvider {
  let instance: TConfig | undefined;

  return {
    provide: ConfigurationCtor,
    useFactory: (authService: AuthService) => {
      if (!instance) {
        instance = new ConfigurationCtor({
          basePath: getBasePath(),
          accessToken: () => authService.getToken(),
        });
      }
      return instance;
    },
    deps: [AuthService],
  };
}

export const coreApiConfigurationProvider = makeApiConfigurationProvider(
  CoreApiConfiguration,
  () => environment.coreApiBasePath,
);

export const houseLpApiConfigurationProvider = makeApiConfigurationProvider(
  HouseLpApiConfiguration,
  () => environment.houseLpApiBasePath,
);

export const zerohashApiConfigurationProvider = makeApiConfigurationProvider(
  ZerohashApiConfiguration,
  () => environment.zerohashApiBasePath,
);

export const fineryApiConfigurationProvider = makeApiConfigurationProvider(
  FineryApiConfiguration,
  () => environment.fineryMarketsApiBasePath,
);

export const principalRiskLpApiConfigurationProvider = makeApiConfigurationProvider(
  PrincipalRiskLpApiConfiguration,
  () => environment.principalRiskLpApiBasePath,
);

export const bBookLpApiConfigurationProvider = makeApiConfigurationProvider(
  BBookLpApiConfiguration,
  () => environment.bBookLpApiBasePath,
);

export const hiddenRoadApiConfigurationProvider = makeApiConfigurationProvider(
  HiddenRoadApiConfiguration,
  () => environment.hiddenRoadApiBasePath,
);

export const mainBookLpApiConfigurationProvider = makeApiConfigurationProvider(
  MainBookLpApiConfiguration,
  () => environment.mainBookLpApiBasePath,
);

export const syntheticLpApiConfigurationProvider = makeApiConfigurationProvider(
  SyntheticLpApiConfiguration,
  () => environment.syntheticLpApiBasePath,
);

export const fireblocksApiConfigurationProvider = makeApiConfigurationProvider(
  FireblocksApiConfiguration,
  () => environment.fireblocksApiBasePath,
);
